module.exports = __webpack_public_path__ + "media/images/4-784f01b20ee640cc16fbd352caf61feb.png";